const LoaderSvg = () => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M38.3926 24.9498C40.3841 24.9498 41.9985 23.3674 41.9985 21.4154C41.9985 19.4633 40.3841 17.8809 38.3926 17.8809C36.4011 17.8809 34.7866 19.4633 34.7866 21.4154C34.7866 23.3674 36.4011 24.9498 38.3926 24.9498Z"
      fill="#1C73E4"
      fill-opacity="0.125"
    />
    <path
      d="M30.7245 35.8207C32.2156 37.2822 34.633 37.2822 36.1241 35.8207C37.6151 34.3592 37.6151 31.9896 36.1241 30.5281C34.633 29.0666 32.2156 29.0666 30.7245 30.5281C29.2335 31.9896 29.2335 34.3592 30.7245 35.8207Z"
      fill="#1C73E4"
      fill-opacity="0.25"
    />
    <path
      d="M17.3967 38.0499C17.3967 40.2316 19.2011 42.0002 21.4269 42.0002C23.6527 42.0002 25.457 40.2316 25.457 38.0499C25.457 35.8682 23.6527 34.0996 21.4269 34.0996C19.2011 34.0996 17.3967 35.8682 17.3967 38.0499Z"
      fill="#1C73E4"
      fill-opacity="0.375"
    />
    <path
      d="M6.4192 30.2355C4.76248 31.8594 4.76248 34.4922 6.4192 36.1161C8.07592 37.74 10.762 37.74 12.4187 36.1161C14.0754 34.4922 14.0754 31.8594 12.4187 30.2355C10.762 28.6116 8.07592 28.6116 6.4192 30.2355Z"
      fill="#1C73E4"
      fill-opacity="0.5"
    />
    <path
      d="M4.45575 17.046C1.99565 17.046 0.00134659 19.0008 0.00134659 21.4122C0.00134659 23.8235 1.99565 25.7783 4.45575 25.7783C6.91585 25.7783 8.91016 23.8235 8.91016 21.4122C8.91016 19.0008 6.91585 17.046 4.45575 17.046Z"
      fill="#1C73E4"
      fill-opacity="0.625"
    />
    <path
      d="M12.728 6.41807C10.9056 4.63179 7.95088 4.63179 6.1285 6.41807C4.30611 8.20435 4.30611 11.1005 6.1285 12.8868C7.95088 14.673 10.9056 14.673 12.728 12.8868C14.5503 11.1005 14.5503 8.20435 12.728 6.41807Z"
      fill="#1C73E4"
      fill-opacity="0.75"
    />
    <path
      d="M26.3032 4.78152C26.3032 2.14051 24.1189 -0.000444412 21.4245 -0.000444412C18.7301 -0.000444412 16.5459 2.14051 16.5459 4.78152C16.5459 7.42252 18.7301 9.56348 21.4245 9.56348C24.1189 9.56348 26.3032 7.42252 26.3032 4.78152Z"
      fill="#1C73E4"
      fill-opacity="0.875"
    />
    <path
      d="M37.0237 13.1797C39.0118 11.2311 39.0118 8.07166 37.0237 6.123C35.0357 4.17433 31.8124 4.17433 29.8243 6.123C27.8363 8.07166 27.8363 11.2311 29.8243 13.1797C31.8124 15.1284 35.0357 15.1284 37.0237 13.1797Z"
      fill="#1C73E4"
    />
  </svg>
);
export default LoaderSvg;
